import { useState } from 'react';
import axios from 'axios';

const useDeleteRequest = () => {
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);
    const [data, setData] = useState(null);
    const baseURL = `${process.env.REACT_APP_BASE_URL}/api/`;

    const del = async (endpoint, config = {}) => {
        setLoading(true);
        setError(null);
        const token = sessionStorage.getItem('authToken');

        const finalConfig = {
            ...config,
            headers: {
                'Content-Type': 'application/json',
                ...(token ? { Authorization: `Bearer ${token}` } : {}),
                ...(config.headers || {}),
            }
        };
        try {
            const response = await axios.delete(baseURL + endpoint, finalConfig);
            setData(response.data);
            return response.data;
        } catch (err) {
            setError(err.response?.data || err.message);
            return err.response?.data;
        } finally {
            setLoading(false);
        }
    };

    return { del, data, loading, error };
};

export default useDeleteRequest;
